import { HttpClient, HttpHeaders, } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  Attachment,
  FileUploadResponse,
} from '@models';
import { firstValueFrom, Observable } from 'rxjs';
import { environment } from '@environment';

@Injectable({
  providedIn: 'root',
})
export class AttachmentService {
  private http = inject(HttpClient);

  createAttachment(
    datasetId: string,
    files: FileList,
    recordId?: string,
    releaseDate?: Date,
    prefix?: string,
  ): Observable<FileUploadResponse[]> {
    const endpoint = `${environment.kinkoHost}/dataset/${datasetId}/attachment/`;

    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      const file = files.item(i);
      if (file && !(file.name === '.' && file.type === '')) {
        if (releaseDate !== undefined) {
          formData.append('released', releaseDate.toISOString());
        }
        if (recordId !== undefined) {
          formData.append('recordId', recordId);
        }
        if (prefix !== undefined) {
          formData.append('prefix', prefix);
        } else if (file?.webkitRelativePath) {
          formData.append('prefix', `/${file.webkitRelativePath.slice(0, file.webkitRelativePath.length - file.name.length)}`);
        }

        formData.append('blob', file);
      }
    }

    return this.http.post<FileUploadResponse[]>(endpoint, formData);
  }

  updateAttachment(
    datasetId: string,
    attachmentId: string,
    attachment: Attachment,
  ): Promise<Attachment> {
    const endpoint = `${environment.kinkoHost}/dataset/${datasetId}/attachment/${attachmentId}`;

    return firstValueFrom(
      this.http.put<Attachment>(endpoint, attachment, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      }),
    );
  }

  deleteAttachment(datasetId: string, attachmentId: string): Promise<void> {
    const endpoint = `${environment.kinkoHost}/dataset/${datasetId}/attachment/${attachmentId}`;
    return firstValueFrom(this.http.delete<void>(endpoint));
  }
}
